import { render, staticRenderFns } from "./AmendmentDocument.vue?vue&type=template&id=505b86d0&scoped=true"
import script from "./AmendmentDocument.vue?vue&type=script&lang=js"
export * from "./AmendmentDocument.vue?vue&type=script&lang=js"
import style0 from "./AmendmentDocument.vue?vue&type=style&index=0&id=505b86d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505b86d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('505b86d0')) {
      api.createRecord('505b86d0', component.options)
    } else {
      api.reload('505b86d0', component.options)
    }
    module.hot.accept("./AmendmentDocument.vue?vue&type=template&id=505b86d0&scoped=true", function () {
      api.rerender('505b86d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/AmendmentDocument.vue"
export default component.exports